import {
    LECTURE_TAG_ID_BL,
    LONGREAD_TAG_ID_BL,
    VISUAL_RES_TAG_ID_BL, VISUAL_RESEARCH_TAG_ASPIRANT,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    ABOUT_ART_TAG_ID,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    PRODUCT_RESEARCH_TAG
} from "../constants/misc";
/*
const visualResearchTags = [
    "b85dd5a16fcd41cf87e292d5733d660f",
    "3h8ecj38fk554a5j439bm4l4ch27dh3g"]*/
const visualResearchTags = [
    VISUAL_RES_TAG_ID_BL,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    LONGREAD_TAG_ID_BL,
    LECTURE_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
    VISUAL_RESEARCH_TAG_ASPIRANT,
    PRODUCT_RESEARCH_TAG
]

export const getHasSpecialSourcesBlocks = (tags: string[]): boolean => {

    if (!tags || tags?.length === 0) return false

    return visualResearchTags.some(tag => tags.includes(tag))
}import {
    LECTURE_TAG_ID_BL,
    LONGREAD_TAG_ID_BL,
    VISUAL_RES_TAG_ID_BL, VISUAL_RESEARCH_TAG_ASPIRANT,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    ABOUT_ART_TAG_ID,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    PRODUCT_RESEARCH_TAG
} from "../constants/misc";
/*
const visualResearchTags = [
    "b85dd5a16fcd41cf87e292d5733d660f",
    "3h8ecj38fk554a5j439bm4l4ch27dh3g"]*/
const visualResearchTags = [
    VISUAL_RES_TAG_ID_BL,
    VISUAL_RESEARCH_TAG_GRADUATION_WHITE,
    VISUAL_RESEARCH_TAG_GRADUATION_BLACK,
    LONGREAD_TAG_ID_BL,
    LECTURE_TAG_ID_BL,
    ABOUT_ART_TAG_ID,
    VISUAL_RESEARCH_TAG_ASPIRANT,
    PRODUCT_RESEARCH_TAG
]

export const getHasSpecialSourcesBlocks = (tags: string[]): boolean => {

    if (!tags || tags?.length === 0) return false

    return visualResearchTags.some(tag => tags.includes(tag))
}